import Icon from '../Icon';
import KindTile from './KindTile';
import {useKindCounts} from '../../api/posts';
import {kindInfo, LATER_KINDS, orderByUsage, TELL_GROUPS} from '../../lib/kinds';
import {Kind} from '../../types';

// The kind picker (design/screens/Tell2Kind): "Your usual", the six this gardener uses most,
// then everything grouped as Concepts groups it, then the kinds still to come. One tap.
type Props = {value: Kind | null; onChoose: (kind: Kind) => void};

export default function KindGrid({value, onChoose}: Props) {
    const counts = useKindCounts();
    const usual = orderByUsage(counts.data ?? {}).slice(0, 6);

    const tile = (kind: Kind) => {
        const info = kindInfo(kind);
        return (
            <button
                key={kind}
                type="button"
                onClick={() => onChoose(kind)}
                aria-pressed={value === kind}
                className={`flex h-[104px] flex-col justify-between rounded-lg border bg-surface p-3 text-left shadow-1 ${value === kind ? 'border-shoot' : 'border-line'}`}
            >
                <KindTile kind={kind} size={44} />
                <span className="text-[15px] font-[650] leading-[1.15]">{info.label}</span>
            </button>
        );
    };

    return (
        <div className="flex flex-col gap-5">
            <section className="flex flex-col gap-2">
                <span className="band-label text-ink-2">Your usual</span>
                <div className="grid grid-cols-3 gap-[10px]">{usual.map(tile)}</div>
            </section>

            {TELL_GROUPS.map(group => (
                <section key={group.label} className="flex flex-col gap-2">
                    <span className="band-label text-ink-2">{group.label}</span>
                    <div className="grid grid-cols-3 gap-[10px]">{group.kinds.map(tile)}</div>
                </section>
            ))}

            <section className="flex flex-col gap-2">
                <span className="band-label text-ink-2">Coming in later releases</span>
                <div className="grid grid-cols-3 gap-2">
                    {LATER_KINDS.map(k => (
                        <div key={k.label} className="flex h-[52px] items-center gap-2 rounded-[14px] border border-dashed border-line px-[10px] text-xs font-semibold text-ink-3" title={`Phase ${k.phase}`}>
                            <Icon name={k.icon} size={20} />
                            {k.label}
                        </div>
                    ))}
                </div>
            </section>
        </div>
    );
}
